import React, { useState, type PropsWithChildren } from 'react';
import Button from '@atlaskit/button/new';
import { Box, Flex, xcss } from '@atlaskit/primitives';
import { BulkOpsWrapper } from '@atlassian/jira-bulk-operations-async-core/src/utils.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import Resizer from '@atlassian/jira-flex-resizer/src/ui/main.tsx';

const DEFAULT_RATIO = 0.35;
const MIN_RATIO = 0.3;
const MAX_RATIO = 0.5;

export const BulkOperationsWrapper = ({ children }: PropsWithChildren) => {
	if (!fg('bulk_operations_in_nin')) {
		return children;
	}

	// eslint-disable-next-line react-hooks/rules-of-hooks
	const [openSidebar, setOpenSidebar] = useState(true);

	return (
		<Flex xcss={wrapperStyles} direction="row">
			<BulkOpsWrapper>
				<Box xcss={childContainerStyles}>{children}</Box>
				{openSidebar && (
					/* TODO: decide on https://hello.jira.atlassian.cloud/browse/DEE-6269
					1. if ratio should be persisted on resize. If yes,
						should it be reset on page redirect (roadmap behaviour), or should it be persisted on next refresh (issue view behaviour)
					2. default ratio
					3. min/max ratio
					*/
					<Resizer defaultRatio={DEFAULT_RATIO} minRatio={MIN_RATIO} maxRatio={MAX_RATIO}>
						{({ ref, style }) => (
							<Box
								testId="issue-navigator.ui.bulk-operations-wrapper.box"
								// eslint-disable-next-line jira/react/no-style-attribute, @atlaskit/ui-styling-standard/enforce-style-prop
								style={style}
								ref={ref}
								padding="space.150"
								xcss={contentStyles}
							>
								<Button onClick={() => setOpenSidebar(false)}>Close Sidebar</Button>
							</Box>
						)}
					</Resizer>
				)}
			</BulkOpsWrapper>
		</Flex>
	);
};

const wrapperStyles = xcss({
	height: '100%',
});

const childContainerStyles = xcss({
	flex: 1,
	overflowY: 'auto',
});

const contentStyles = xcss({
	overflowY: 'auto',
});
